import { createApi } from "@reduxjs/toolkit/query/react";
import { Account } from "@shared/models";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export type GetCompanyListResponse = {
  items: Account[];
  total: number;
};

export type GetCompanyListParams = {
  search?: string;
  page?: number;
  limit?: number;
  order?: string;
  direction?: string;
};

export const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  endpoints: (builder) => ({
    getCompanyList: builder.query<GetCompanyListResponse, GetCompanyListParams>({
      query: (params) => {
        return {
          url: "accounts",
          params,
        };
      },
    }),
  }),
});

export const { useGetCompanyListQuery } = companyApi;
